import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 收入预测-查询 -xsh
export const getRevenueForecastPage = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/page',
        method: 'post',
        data
    });
};
// 收入预测-保存-xsh
export const revenueForecastPageSave = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/save',
        method: 'post',
        data
    });
};
// -xsh 收入预测-获取当前用户权限 数据权限：行业大类_财经专用 或分公司权限_财经专用、经营中心-财经专用、专业公司_财经专用 或按个人
export const revenueForecastAuthRole = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/authRole',
        method: 'post',
        data
    });
};

// 收入预测-导入-xsh
export const revenueForecastImportApi = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/import',
        method: 'post',
        data
    });
};

// 收入预测-新增商机-xsh
export const updateRevenueForecast = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/add/batch',
        method: 'post',
        data
    });
};
// 收入预测-刷新商机-xsh
export const updateOpportunityApi = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/add/refresh',
        method: 'post',
        data
    });
};
// 收入预测-批量删除-xsh
export const revenueForecastBatchDelete = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/delete/batch',
        method: 'post',
        data
    });
};
// 收入预测-填报状态-xsh
export const getLockCheck = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/lockStatus',
        method: 'post',
        data
    });
};
// 收入预测-保存填报状态-xsh
export const saveLockStatus = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/updateLockStatus',
        method: 'post',
        data
    });
};
// 收入预测-生成专司预测-xsh
export const createProfessionalCompany = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/createFillForecast',
        method: 'post',
        data
    });
};

// 收入预测-获取详情 前端：lx；后端：xsh
export const getRevenueForecastByFillId = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/getByFillId',
        method: 'post',
        data
    });
};

// 收入预测-当前用户是否特权角色 前端：lx；后端：xsh
export const getPrivilegedRole = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/privilegedRole',
        method: 'post',
        data
    });
};

// 收入预测-导出-xsh
export const revenueForecastExport = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecast/export',
        method: 'post',
        data
    });
};

// 收入预测版本 任务详情 -ylx
export const getCommissionDetail = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/todo/detail',
        method: 'post',
        data
    });
};

// 收入预测版本 任务提交 ylx
export const saveCommission = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastVersion/todo/submit',
        method: 'post',
        data
    });
};
